export const userFormSiteFields = ['siteName']